// Musculoskeletal subsection form field enum
export enum MusculoskeletalFormField {
  MUSCULOSKELETAL_ASSESSMENT = 'medical-background/musculoskeletal/musculoskeletal-assessment',
  MUSCULOSKELETAL_SYSTEM_SUMMARY = 'medical-background/musculoskeletal/system-summary'
}
